import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGallary } from "../gallaryModal";

export const getAllGallarys = createAsyncThunk(
  "Gallary/FindAllGallary",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Gallary/FindAllGallary`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Gallary images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createGallary = createAsyncThunk(
  "Gallary/InsertGallary",
  async (GallaryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallary/InsertGallary`,
        GallaryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Gallary Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateGallary = createAsyncThunk(
  "Gallary/CreateOrUpdateGallary",
  async (GallaryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallary/CreateOrUpdateGallary`,
        GallaryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Gallary Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteGallary = createAsyncThunk(
  "Gallary/DeleteGallary",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallary/DeleteGallary`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Gallary Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getGallaryByID = createAsyncThunk(
  "Gallary/FindByIDGallary",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallary/FindByIDGallary`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ImgAlt: result?.ImgAlt ?? "",
        GallaryImage: result?.GallaryImage ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IGallary;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Gallary Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveGallarys = createAsyncThunk(
  "Gallary/FindAllActiveGallary",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Gallary/FindAllActiveGallary`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Gallary images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveGallary = createAsyncThunk(
  "Gallary/ActiveInActiveGallary",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallary/ActiveInActiveGallary`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Gallary Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

// export const GallaryImageUpload = createAsyncThunk(
//   "Gallary/UpdateGallary",
//   async (formData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/Gallary/UpdateGallary`,
//         formData,
//         {
//           headers: { "content-type": "multipart/form-data" },
//         }
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error upload Gallary Image Image :", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );
